"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var config_1 = require("../config");

var Icon_1 = __importStar(require("../Icon"));

var FileBar =
/** @class */
function (_super) {
  __extends(FileBar, _super);

  function FileBar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.fileSize = function (sizeInBytes) {
      var unit = 'B';
      var size = sizeInBytes;

      if (size >= 1024 * 1024) {
        unit = 'MB';
        size = Math.ceil(size / (1024 * 1024) * 100) / 100;
      } else if (size >= 1024) {
        unit = 'KB';
        size = Math.ceil(size / 1024 * 100) / 100;
      }

      return size + " " + unit;
    };

    _this.onRemoveClick = function () {
      if (_this.props.onDelete) {
        _this.props.onDelete();
      }
    };

    return _this;
  }

  FileBar.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        total = _a.total,
        title = _a.title,
        onDelete = _a.onDelete,
        onClick = _a.onClick;
    var b = config_1.block('file_bar');
    return react_1.default.createElement("div", {
      onClick: onClick,
      className: b({}).mix(className)
    }, react_1.default.createElement(Icon_1.default, {
      className: b('icon').toString(),
      icon: Icon_1.IconType.Document,
      width: 20,
      height: 20
    }), react_1.default.createElement("div", {
      className: b('title')
    }, title), total && react_1.default.createElement("span", {
      className: b('size')
    }, this.fileSize(total)), onDelete && react_1.default.createElement("a", {
      className: b('remove'),
      onClick: this.onRemoveClick
    }, react_1.default.createElement(Icon_1.default, {
      icon: Icon_1.IconType.Cross,
      width: 20,
      height: 20
    })));
  };

  return FileBar;
}(react_1.default.Component);

exports.default = FileBar;